import { atom } from "jotai";
import { atomWithImmer } from "jotai-immer";

import { projectApi } from "../services";
import type { ProjectQuickview } from "../types";

export type ProjectQuickviewState = {
  projectId: number | null;
  project: ProjectQuickview | null;
  loading: boolean;
  error: string | null;
};

export const initialProjectQuickviewState: ProjectQuickviewState = {
  projectId: null,
  project: null,
  loading: false,
  error: null,
};

export const projectQuickviewAtom = atomWithImmer<ProjectQuickviewState>(
  initialProjectQuickviewState,
);

export const openProjectQuickviewAtom = atom(
  null,
  async (get, set, projectId: number): Promise<void> => {
    set(projectQuickviewAtom, (draft) => {
      draft.projectId = projectId;
      draft.loading = true;
      draft.error = null;
    });

    try {
      const project = await projectApi.fetchQuickview(projectId);

      if (projectId !== get(projectQuickviewAtom).projectId) {
        return;
      }

      set(projectQuickviewAtom, (draft) => {
        draft.project = project;
        draft.loading = false;
      });
    } catch (error: unknown) {
      if (projectId !== get(projectQuickviewAtom).projectId) {
        return;
      }

      set(projectQuickviewAtom, (draft) => {
        draft.project = null;
        draft.loading = false;
        draft.error = error instanceof Error ? error.message : String(error);
      });
    }
  },
);

export const shownProjectQuickviewIdAtom = atom(
  (get) => get(projectQuickviewAtom).projectId,
);

export const refreshProjectQuickviewAtom = atom(
  null,
  async (get, set): Promise<void> => {
    const { projectId } = get(projectQuickviewAtom);

    if (null === projectId) {
      return;
    }

    await set(openProjectQuickviewAtom, projectId);
  },
);

export const closeProjectQuickviewAtom = atom(null, (_get, set): void => {
  set(projectQuickviewAtom, () => initialProjectQuickviewState);
});
